<template>
<div class="step step--type-1">
<div class="step__main">
<h2 class="heading-step">
<span class="heading-step__step">STEP<em>1</em> </span>
<span class="heading-step__title">お客さま情報の入力</span>
<!-- /.heading-step --></h2>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col">
<h3 class="heading-label"><label for="label-dummy-agree-01">年齢</label></h3>

<div class="form-select">
<select name="name-dummy-agree-01" id="label-dummy-agree-01" class="form-select__select" v-model="value1" @change="changeValue1ByEvent">
<option value="">選択ください</option>
<option value="16">16歳</option>
<option value="17">17歳</option>
<option value="18">18歳</option>
<option value="19">19歳</option>
<option value="20">20歳</option>
<option value="21">21歳</option>
<option value="22">22歳</option>
<option value="23">23歳</option>
<option value="24">24歳</option>
<option value="25">25歳</option>
<option value="26">26歳</option>
<option value="27">27歳</option>
<option value="28">28歳</option>
<option value="29">29歳</option>
<option value="30">30歳</option>
<option value="31">31歳</option>
<option value="32">32歳</option>
<option value="33">33歳</option>
<option value="34">34歳</option>
<option value="35">35歳</option>
<option value="36">36歳</option>
<option value="37">37歳</option>
<option value="38">38歳</option>
<option value="39">39歳</option>
<option value="40">40歳</option>
<option value="41">41歳</option>
<option value="42">42歳</option>
<option value="43">43歳</option>
<option value="44">44歳</option>
<option value="45">45歳</option>
<option value="46">46歳</option>
<option value="47">47歳</option>
<option value="48">48歳</option>
<option value="49">49歳</option>
<option value="50">50歳</option>
<option value="51">51歳</option>
<option value="52">52歳</option>
<option value="53">53歳</option>
<option value="54">54歳</option>
<option value="55">55歳</option>
<option value="56">56歳</option>
<option value="57">57歳</option>
<option value="58">58歳</option>
<option value="59">59歳</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>

<div class="column__col">
<h3 class="heading-label">性別</h3>

<div class="form-radio">
<label class="form-radio__label">
<input type="radio" name="name-dummy-gender-01" class="form-radio__label-radio" value="男性" v-model="value2" @change="changeValue2ByEvent">
<span class="form-radio__label-text">男性</span>
<!-- /.form-radio__label --></label>

<label class="form-radio__label">
<input type="radio" name="name-dummy-gender-01" class="form-radio__label-radio" value="女性" v-model="value2" @change="changeValue2ByEvent">
<span class="form-radio__label-text">女性</span>
<!-- /.form-radio__label --></label>
<!-- /.form-radio --></div>
<!-- /.column__col --></div>

<div class="column__col">
<h3 class="heading-label"><label for="label-works-01">職業区分</label></h3>

<div class="form-select">
<select name="name-dummy-works-01" id="label-works-01" class="form-select__select" v-model="value3" @change="changeValue3ByEvent">
<option value="">選択ください</option>
<option value="自営業">自営業</option>
<option value="会社員・公務員">会社員・公務員</option>
<option value="専業主婦・専業主夫">専業主婦・専業主夫</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>

<div class="column column--col-3" id="plans" v-show="value3 === '専業主婦・専業主夫'">
<div class="column__inner">
<div class="column__col column__col--col-2">
<h3 class="heading-label">加入の公的医療保険</h3>

<div class="form-radio">
<label class="form-radio__label">
<input type="radio" name="name-dummy-plan-01" class="form-radio__label-radio" value="健康保険の被扶養者" v-model="value4" @change="changeValue4ByEvent">
<span class="form-radio__label-text">健康保険の被扶養者</span>
<!-- /.form-radio__label --></label>

<label class="form-radio__label">
<input type="radio" name="name-dummy-plan-01" class="form-radio__label-radio" value="国保の加入者" v-model="value4" @change="changeValue4ByEvent">
<span class="form-radio__label-text">国民健康保険の加入者</span>
<!-- /.form-radio__label --></label>
<!-- /.form-radio --></div>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>

<div class="column column--col-3">
<div class="column__inner">
<div class="column__col">
<h3 class="heading-label"><label>配偶者の有無</label></h3>

<div class="form-radio">
<label class="form-radio__label">
<input type="radio" name="name-dummy-spouse-01" class="form-radio__label-radio" value="1" v-model="value5" @change="changeValue5ByEvent">
<span class="form-radio__label-text">あり</span>
<!-- /.form-radio__label --></label>

<label class="form-radio__label">
<input type="radio" name="name-dummy-spouse-01" class="form-radio__label-radio" value="0" v-model="value5" @change="changeValue5ByEvent">
<span class="form-radio__label-text">なし</span>
<!-- /.form-radio__label --></label>
<!-- /.form-radio --></div>
<!-- /.column__col --></div>

<div class="column__col" v-show="1 === value5">
<h3 class="heading-label"><label for="label-dummy-spouse-02">配偶者の年齢</label></h3>

<div class="form-select">
<select name="name-dummy-spouse-02" id="label-dummy-spouse-02" class="form-select__select" v-model="value6" @change="changeValue6ByEvent">
<option value="">選択ください</option>
<option value="16">16歳</option>
<option value="17">17歳</option>
<option value="18">18歳</option>
<option value="19">19歳</option>
<option value="20">20歳</option>
<option value="21">21歳</option>
<option value="22">22歳</option>
<option value="23">23歳</option>
<option value="24">24歳</option>
<option value="25">25歳</option>
<option value="26">26歳</option>
<option value="27">27歳</option>
<option value="28">28歳</option>
<option value="29">29歳</option>
<option value="30">30歳</option>
<option value="31">31歳</option>
<option value="32">32歳</option>
<option value="33">33歳</option>
<option value="34">34歳</option>
<option value="35">35歳</option>
<option value="36">36歳</option>
<option value="37">37歳</option>
<option value="38">38歳</option>
<option value="39">39歳</option>
<option value="40">40歳</option>
<option value="41">41歳</option>
<option value="42">42歳</option>
<option value="43">43歳</option>
<option value="44">44歳</option>
<option value="45">45歳</option>
<option value="46">46歳</option>
<option value="47">47歳</option>
<option value="48">48歳</option>
<option value="49">49歳</option>
<option value="50">50歳</option>
<option value="51">51歳</option>
<option value="52">52歳</option>
<option value="53">53歳</option>
<option value="54">54歳</option>
<option value="55">55歳</option>
<option value="56">56歳</option>
<option value="57">57歳</option>
<option value="58">58歳</option>
<option value="59">59歳</option>
<option value="60">60歳</option>
<option value="61">61歳</option>
<option value="62">62歳</option>
<option value="63">63歳</option>
<option value="64">64歳</option>
<option value="65">65歳</option>
<option value="66">66歳</option>
<option value="67">67歳</option>
<option value="68">68歳</option>
<option value="69">69歳</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>

<div class="column__col column__col--col-2">
<h3 class="heading-label"><label for="label-dummy-child-01">18歳到達年度末日までのお子さまの人数</label></h3>

<div class="form-select">
<select name="name-dummy-child-01" id="label-dummy-child-01" class="form-select__select" v-model="value7" @change="changeValue7ByEvent">
<option value="">選択ください</option>
<option value="0">0名</option>
<option value="1">1名</option>
<option value="2">2名</option>
<option value="3">3名</option>
<option value="4">4名</option>
<option value="5">5名以上</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>
<!-- /.column__inner --></div>
<!-- /.column --></div>

<ul class="list-notice">
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>この試算ツールは2018年度の年金額を基に作成しています。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>この試算ツールは60歳未満の方が対象です。</small></li>
<li class="list-notice__item"><small><span class="list-notice__item-mark">※ </span>この試算ツールの結果は、お客さまのねんきん定期便の情報および年収等が正しく入力されることを前提として算出しています。桁数を誤って入力した場合等であってもそのまま結果が反映されてしまうため、正確な入力をお願いします。</small></li>
<!-- /.list-notice --></ul>
<!-- /.step__main --></div>

<div class="step__foot">
<div class="button-submit">
<router-link tag="button" type="button" class="button-submit__button" to="step2agency" v-if="validateStep1 && agencyMode">
<span class="button-submit__button-inner">STEP2へ</span>
<!-- /.button-submit__button --></router-link>
<router-link tag="button" type="button" class="button-submit__button" to="step2" v-else-if="validateStep1">
<span class="button-submit__button-inner">STEP2へ</span>
<!-- /.button-submit__button --></router-link>
<router-link tag="button" type="button" class="button-submit__button" to="step2" v-else disabled>
<span class="button-submit__button-inner">STEP2へ</span>
<!-- /.button-submit__button --></router-link>
<!-- /.button-submit --></div>
<!-- /.step__foot --></div>
<!-- /.step --></div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Utils from '../assets/js/Utils';

    export default {
        name: 'step1',
        computed: {
            ...mapGetters([
                'agencyModal',
                'agencyCode',
                'agentCode',
                'agencyMode',
                'value1_text',
                'value2_text',
                'value3_text',
                'value4_text',
                'value5_text',
                'value6_text',
                'value7_text',
                'validateStep1'
            ]),
            value1: {
                get() {
                    return this.$store.getters.value1;
                },
                set(value) {
                    this.changeValue1(value);
                }
            },
            value2: {
                get() {
                    return this.$store.getters.value2;
                },
                set(value) {
                    this.changeValue2(value);
                }
            },
            value3: {
                get() {
                    return this.$store.getters.value3;
                },
                set(value) {
                    this.changeValue3(value);
                }
            },
            value4: {
                get() {
                    return this.$store.getters.value4;
                },
                set(value) {
                    this.changeValue4(value);
                }
            },
            value5: {
                get() {
                    return this.$store.getters.value5;
                },
                set(value) {
                    this.changeValue5(value);
                }
            },
            value6: {
                get() {
                    return this.$store.getters.value6;
                },
                set(value) {
                    this.changeValue6(value);
                }
            },
            value7: {
                get() {
                    return this.$store.getters.value7;
                },
                set(value) {
                    this.changeValue7(value);
                }
            }
        },
        methods: {
            ...mapActions([
                'changeValue1',
                'changeValue1Text',
                'changeValue2',
                'changeValue2Text',
                'changeValue3',
                'changeValue3Text',
                'changeValue4',
                'changeValue4Text',
                'changeValue5',
                'changeValue5Text',
                'changeValue6',
                'changeValue6Text',
                'changeValue7',
                'changeValue7Text'
            ]),
            changeValue1ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue1Text(textContent);
            },
            changeValue2ByEvent(event) {
                const currentTarget = event.currentTarget;
                const labelText = Utils.findLabelTextByInputElement(currentTarget);

                this.changeValue2Text(labelText);
            },
            changeValue3ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue3Text(textContent);
            },
            changeValue4ByEvent(event) {
                const currentTarget = event.currentTarget;
                const labelText = Utils.findLabelTextByInputElement(currentTarget);

                this.changeValue4Text(labelText);
            },
            changeValue5ByEvent(event) {
                const currentTarget = event.currentTarget;
                const labelText = Utils.findLabelTextByInputElement(currentTarget);

                this.changeValue5Text(labelText);
            },
            changeValue6ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue6Text(textContent);
            },
            changeValue7ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue7Text(textContent);
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const s = window.s;

                if (s) {
                    if (!vm.agencyModal && from.name !== null && to.name === 'Step1') {
                        // 他 STEP からの戻り時
                        let agencyVariableString;
                        let sCode;

                        if (vm.agencyMode) {
                            agencyVariableString = vm.agencyCode + '|' + vm.agentCode;
                        } else {
                            agencyVariableString = '|';
                        }

                        s.pageName = '【RWD】公的保障試算ツール(STEP1)';
                        s.prop11 = agencyVariableString;
                        s.eVar11 = agencyVariableString;
                        s.prop12 = '';
                        s.eVar12 = '';
                        s.prop13 = '';
                        s.eVar13 = '';
                        s.prop14 = '';
                        s.eVar14 = '';
                        s.prop15 = '';
                        s.eVar15 = '';
                        s.events = '';
                        s.linkTrackEvents = '';

                        sCode = s.t();

                        if (sCode) {
                            document.write(sCode);
                        }
                    }
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            const sendTrackingCode = () => {
                const s = window.s;

                if (s) {
                    if (from.name === 'Step1' && (to.name === 'Step2' || to.name === 'Step2Agency')) {
                        const values = [
                            this.value1_text,
                            this.value2_text,
                            this.value3_text,
                            this.value4_text,
                            this.value5_text,
                            this.value6_text,
                            this.value7_text
                        ];
                        const joinedValues = values.join('|');

                        s.prop12 = joinedValues;
                        s.eVar12 = joinedValues;
                        s.linkTrackVars = 'prop12,eVar12,events';
                        s.events = 'event2';
                        s.linkTrackEvents = 'event2';
                        s.tl(window, 'o', '公的保障試算ツール STEP2へ');
                    }
                }
            };

            if (!this.agencyMode && from.name === 'Step1' && to.name === 'Step2') {
                if (this.validateStep1) {
                    sendTrackingCode();
                    next();
                } else {
                    next(false);
                }
            } else if (this.agencyMode && from.name === 'Step1' && to.name === 'Step2Agency') {
                if (this.validateStep1) {
                    sendTrackingCode();
                    next();
                } else {
                    next(false);
                }
            } else {
                next(false);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Step1.vue